import React from 'react';
import ContentBlock from '../ContentBlock';
import getImageUrl from '../../utils/getImageURL';

export default function CaseStudy({ caseStudy, layout, bgColor, showAuthor }) {
  if (!caseStudy) {
    return <div />;
  }
  const { quote, slug, author_avatar, title } = caseStudy;

  const Contents = () => (
    <ContentBlock
      title={title}
      linkURL={`/case-studies/${slug}/`}
      linkLabel="Read case study"
      shadow
      align={layout === 'left' ? 'right' : 'left'}
    >
      <div
        className={`max-w-[60rem] py-5 px-0 lg:py-10 lg:px-10 text-left lg:text-center text-base lg:text-lg leading-normal text-black/[0.8] rounded-2xl ${
          showAuthor ? 'mb-8' : 'mb-0'
        }`}
      >
        {showAuthor && (
          <div
            style={{
              width: 100,
              height: 100,
              marginBottom: '1rem',
              borderRadius: '100%',
              display: 'inline-block',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundImage: `url(${getImageUrl(author_avatar, 200)})`,
            }}
          />
        )}
        <p style={{ marginBottom: 0 }}>&ldquo;{quote}&rdquo;</p>
      </div>
    </ContentBlock>
  );

  return bgColor ? (
    <div className="w-full" style={{ backgroundColor: bgColor }}>
      <Contents />
    </div>
  ) : (
    <Contents />
  );
}
